module.exports = __webpack_public_path__ + "img/unpermitted.2514cf9f.png";